import React from 'react';

import useClassy from '@core/hooks/useClassy';

import Flex from '@ui/Flex';

import TreeConnector from '../TreeConnector';

import styles from './EmptyBranches.module.scss';

/** Default height of the empty branches item in the virtual list. */
export const EMPTY_BRANCHES_ITEM_HEIGHT = 27;

interface EmptyBranchesItemProps {
  style: React.CSSProperties;
}

export function EmptyBranchesItem({ style }: EmptyBranchesItemProps) {
  const bem = useClassy(styles, 'EmptyBranchesItem');

  return (
    <Flex align="center" className={bem()} gap="sm" justify="start" style={style}>
      <TreeConnector kind="end" />
      No branches
    </Flex>
  );
}
